import { type ColumnOptions } from "interfaces";

export const getGroupsColumnOptions = (): ColumnOptions[] => [
  {
    name: "Name",
    width: 9,
    isSortable: true,
  },
  {
    name: "Members",
    width: 4,
    isSortable: false,
  },
  {
    name: "Added",
    width: 3,
    isSortable: true,
  },
];
